import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'

import MultiSelectItem from './multi-select-item'
import buildName from '@/modules/todo/components/_helpers/buildName'
import { MultiSelectItemObj } from '@/components/multi-select/types'
import lang from '@/lang'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    height: '100%',
  },
  externalAdd: {
    padding: '17px',
    color: theme.primary,
    fontSize: theme.fontSizes.smaller,
    cursor: 'pointer',
  },
}))

type MultiSelectListProps = {
  items: MultiSelectItemObj[],
  hiddenValues: MultiSelectItemObj[],
  searchTerm: string,
  selectedItem?: MultiSelectItemObj,
  onChange?: (item: MultiSelectItemObj) => void
  onAdd?: () => void
}

const MultiSelectList = (props: MultiSelectListProps) => {
  const classes = useStyles()
  const {
    items = [],
    hiddenValues = [],
    selectedItem = null,
    searchTerm = '',
    onChange,
    onAdd,
  } = props

  const onAddNewClick = () => {
    onAdd?.()
  }

  const itemEls = useMemo(() => {
    return items
      .map((item, index) => {
        const active = selectedItem?.email === item.email
        const name = `${buildName(item)} ${(item.customerId || item.supplierId) ? `(${lang.contactPersonTitle})` : ''}`
        return (
          <MultiSelectItem
            key={`item-${index}`}
            active={active}
            label={name}
            item={item}
            onClick={(item) => {
              onChange?.(item)
            }} />
        )
      })
  }, [hiddenValues, items])

  return (
    <div className={classes.root}>
      {itemEls.length > 0 && itemEls}
      {searchTerm && (
        <div
          className={classes.externalAdd}
          onClick={onAddNewClick}>
          {searchTerm} {lang.multiSelect.add}
        </div>
      )}
    </div>
  )
}

export default MultiSelectList
